/**
 * Component to show the listing information for profiles passed
 */
import * as React from 'react';
import Util from '../common/utils';
import { Table } from 'antd';
import { IcommonProps } from '../common/props';
import TestList from '../test/TestList';
import '../../css/ProfileList.scss';
import { Link } from 'react-router-dom';
import Constants from '../common/constants';
import Auth from '../common/auth';
import { Tasks } from '../common/auth';
import strings from '../../eyeguide-localization/profile/strings.profile.list';
import Token from '../common/token';
import { CustomSorter } from '../Sorter';
/**
 * Property definition 
 */
interface IProfileListProps extends IcommonProps {
    profiles: Array<any>;
    notifyShowTestsClick: any;
    tests: any;
    showOrg: any;
    showNotifs: any;
    emptyText: string;
    loading: boolean;
    testListLoading: boolean;
    testListText: string;
}

/**
 * State definition
 */
interface IProfileListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
    selectedRowKeys: Array<string>;    
    childColumnNames: any;
    emptyText: string;
    testListLoading: boolean;
    testListText: string;
    currentPageSize: number;
    canEditProfile: boolean;
    showHealthData: boolean;
}

/**
 * Listing component for displaying the profiles
 */
export default class ProfileList extends React.Component<IProfileListProps, IProfileListState> {

    rowClass: string = 'rows';

    constructor(props: IProfileListProps) {
        super(props);
        console.log('Tasks.canEditProfile', Tasks.canEditProfile);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
            columnData: [],
            columns: [],
            pagination: {},
            loading: true,
            selectedRowKeys: [],
            childColumnNames: ['name', 'value'],
            emptyText: '',
            testListLoading: false,
            testListText : '',
            currentPageSize: 20,
            canEditProfile: Auth.canPerformTask(roleid, Tasks.canEditProfile),
            showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData)
        };        
        console.log('this.state', this.state) ;
        this.onShowSizeChange = this.onShowSizeChange.bind(this);
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);

    }

    componentWillReceiveProps(nextProps: any) {
        let columnData: any[] = this.buildData(nextProps.profiles);
        let columns = this.buildColumns(nextProps);
        const pagination = { ...this.state.pagination };
        pagination.total = nextProps.profiles.length;
        pagination.onShowSizeChange = this.onShowSizeChange;
        pagination.pageSize = this.state.currentPageSize ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return strings.formatString(strings.lsTotalProfilesTxt, total);
        };
        this.setState({
            loading: nextProps.loading,
            columnData: columnData,
            columns: columns,
            pagination,
            emptyText: nextProps.emptyText,
            testListLoading: nextProps.testListLoading,
            testListText : nextProps.testListText
        });
    }

    /**
     * Render function called when row is expanded. Returns the HTML elements to display
     */
    _expandRowRender = (record: any, expanded: any, expandedRowKeys: any) => {
        console.log('_expandRowRender', record);
        console.log('_expandRowRender', expanded);
        console.log('expandedRowKeys', expandedRowKeys);       
        return(
            <TestList 
                organizationID={this.props.organizationID} 
                rosterID={this.props.rosterID} 
                tests={this.props.tests.has(record.playerid) ? this.props.tests.get(record.playerid) : []}
                notifySelectedTests={undefined}
                organizationName={this.props.organizationName}
                enableTitleSpace={this.props.enableTitleSpace}
                pagination={false}
                sorting={false}
                showAthelete={false}
                showDownloadAction={false}
                loading={this.state.testListLoading}
                emptyText={this.state.testListText}
                showEditAction={false}
                notifyTestUpdated={undefined}
                fromProfileList={true}
            />
        );
    }

    /**
     * Notifies Profiles Component to fetch last baseline tests for the record
     * @param record Record that is expanded
     */
    getTests(record: any) {
        this.props.notifyShowTestsClick(record.playerid);
    }
  
    render() {
        console.log('Profilelist render called');        
        return (           
            <div>        
            <Table 
                className="ProfileList"
                columns={this.state.columns} 
                dataSource={this.state.columnData} 
                pagination={this.state.pagination}
                rowKey={record => record.playerid}
                loading={this.state.loading}
                expandedRowRender={this._expandRowRender}
                onExpand={this.onExpand}
                rowClassName={(record, index) => 'rows'}
                expandRowByClick={true}
                locale={{ emptyText: this.state.emptyText }} 
                
            />        

            </div>        
        );            
    }

    /**
     * This function builds the data required by the Table component to display the profiles
     * @param profiles Profile array containing the profiles to be dispalyed
     */
    private buildData(profiles: Array<any>) {
        let columnData: Array<any> = [];
        if (profiles !== null) {
            profiles.forEach( (element: any) => {
                let data = {
                    organization: element.organizationname,
                    firstname: element.firstname,
                    middlename: Util.getProfileValue(element.playerinfo, 'middlename'),
                    lastname: element.lastname,
                    level: Util.getProfileValue(element.playerinfo, 'level'),
                    id: Util.getProfileValue(element.playerinfo, 'profileID'),
                    gender: this.getName( Util.getProfileValue(element.playerinfo, 'gender'), Constants.getGender()),
                    concussed: Util.getConcussed(element.concussed),
                    playerid: element.playerid,
                    notifyPhone: Util.getProfileValue(element.playerinfo, 'notifyPhone'),
                    notifyEmail: Util.getProfileValue(element.playerinfo, 'notifyEmail')

                };
                columnData.push(data);
            }); 
        }
        return columnData;
    }

    /**
     * Fetches the test list for the player whose profile is expanded
     * This function is called by list itself
     */
    private onExpand = (expanded: any, record: any) => {
        if (expanded) {
            if (!this.props.tests.has(record.playerid)) {
                this.getTests(record);
            }
        }
    }

    private getName(value: any, list: any) {
        return list[value];
    }
    
    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns(nextProps: any) {
        let columns = [
            nextProps.showOrg ? {
            title: strings.lsOrgTxt,
            dataIndex: 'organization',
            sorter: (a: any, b: any) => a.organization.localeCompare(b.organization),
            defaultSortOrder: 'ascend',
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    title={text}
                    style={{width: '130px'}}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }

        } : {}, 
          {
            title: strings.lsFirstName,
            dataIndex: 'firstname',
            sorter: (a: any, b: any) => a.firstname.localeCompare(b.firstname),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsMiddleName,
            dataIndex: 'middlename',
            sorter: (a: any, b: any) => a.middlename.localeCompare(b.middlename),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsLastName,
            dataIndex: 'lastname',
            sorter: (a: any, b: any) => a.lastname.localeCompare(b.lastname),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          !(nextProps.showNotifs) ? {
            title: strings.lsLevelTxt,
            dataIndex: 'level',
            sorter: (a: any, b: any) => {
                let alevel = a.level !== null ? a.level : '';
                let blevel = b.level !== null ? b.level : '';
                return alevel <= blevel ? -1 : 1;
                },
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } : {},
          !nextProps.showNotifs ? {
            title: strings.lsIDTxt,
            dataIndex: 'id',
            sorter: (a: any, b: any) => a.id.localeCompare(b.id),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '50px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } : {},
          !nextProps.showNotifs ? {
            title: strings.lsGenderTxt,
            dataIndex: 'gender',
            sorter: (a: any, b: any) => {
                let agender = a.gender !== null ? a.gender : '';
                let bgender = b.gender !== null ? b.gender : '';
                return agender <= bgender ? -1 : 1;
                },
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } : {},
          (!(screen.width <= 1280) && nextProps.showNotifs) ? {
            title: strings.lsNotifyEmailTxt,
            dataIndex: 'notifyEmail',
            sorter: (a: any, b: any) => a.notifyEmail.localeCompare(b.notifyEmail),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }

        } : {}, 
        (!(screen.width <= 1280) && nextProps.showNotifs) ? {
            title: strings.lsNotifyPhonesTxt,
            dataIndex: 'notifyPhone',
            sorter: (a: any, b: any) => a.notifyPhone.localeCompare(b.notifyPhone),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }

        } : {}, 
        // nextProps.showNotifs === false && this.state.showHealthData ? {
        //     title: strings.lsConcussionTxt,
        //     dataIndex: 'concussed',
        //     sorter: (a: any, b: any) => a.concussed.toString().localeCompare(b.concussed.toString()),
        //     className: 'rows'
        //   } : {},
          {
            title: strings.lsActionTxt,
            dataIndex: 'playerid',            
            render: (text: any, record: any) => (
                <div>
                    {this.state.canEditProfile ? <Link 
                        // className="linkSpacing"
                        to={'/profile/edit/' + record.playerid}
                    >{strings.lsEditTxt + ' | '}
                    </Link> : ''}
                    <Link 
                        // className="linkSpacing"
                        to={'/profile/view/' + record.playerid}
                    >{strings.lsViewTxt}
                    </Link> 
                </div>
            )
          }
        ];
        return columns;
    }
    
    private onShowSizeChange(current: number, size: number) {
        console.log('onShowSizeChange', current);
        console.log('onShowSizeChange', size);
        let pagination = this.state.pagination;
        pagination.pageSize = size;
        this.setState({
            currentPageSize: size,
            pagination
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/ProfileList.tsx